// extracted by mini-css-extract-plugin
module.exports = {"background-image":"BackgroundImage_background-image__NULgV"};